import { FormattedUser } from '../hooks/graphql/users/useOrganizationUsers';
import { formatPhoneNumber } from './formatters';

export const buildUserLabel = (user: FormattedUser): string => {
  const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || user.email;
  return user.phone_number ? `${name} (${formatPhoneNumber(user.phone_number)})` : name;
};

/** Options keyed by userId — use for assignedAgentId filters */
export const buildUserOptions = (users: FormattedUser[]) =>
  [...users]
    .sort((a, b) => (a.firstName ?? '').localeCompare(b.firstName ?? ''))
    .map((user) => ({ value: user.id, label: buildUserLabel(user) }));

/** Options keyed by phone_number — use where phone is required (e.g. bulk assign) */
export const buildUserOptionsByPhone = (users: FormattedUser[]) =>
  [...users]
    .sort((a, b) => (a.firstName ?? '').localeCompare(b.firstName ?? ''))
    .map((user) => ({ value: user.phone_number, label: buildUserLabel(user) }));
